const merge = require('lodash/merge')
const get = require('lodash/get')
const forEach = require('lodash/forEach')
const endsWith = require('lodash/endsWith')
const angular = require('angular')
const LA = require('la-js-sdk').default
const { vconsole: globalVconsole, config: globalConfig, hook: globalHook } = require('js/global/module')
const serverConfig = require('../infrastructure/serverConfig')

const convertToAbsURL = function(url) {
  if (!url) return url

  // url允许配置相对路径或者绝对路径
  const node = document.createElement('a')
  node.href = url
  url = node.href
  url = endsWith(url, '/') ? url.slice(0, -1) : url
  // 如果配置的是一个origin的话，要补全 URL 后缀 /coremail
  const origin = node.href.match(/^https?:\/\/[^/]+/)
  url += origin && origin[0] === url ? '/coremail' : ''
  return url
}

module.exports = ['$scope', '$q', '$translate', '$location', 'Promise', '$cookies', '$utils', '$rootScope', '$state',
  '$ionicConfig', '$ionicPopup', 'User', 'HttpInterceptor', 'LocalStorage', 'Skin', 'JSBridge', 'IndexedDB',
  function ($scope, $q, $translate, $location, Promise, $cookies, $utils, $rootScope, $state,
    $ionicConfig, $ionicPopup, User, HttpInterceptor, LocalStorage, Skin, JSBridge, IndexedDB) {
    $rootScope.settings = globalConfig.settings
    checkEnv()
    initWechatData()

    $rootScope.isPadMode = window.innerWidth >= 768
    $rootScope.isAppEmbed = $utils.$misc.MD.isAppEmbed
    $rootScope.isReadOnly = $location.$$search.isReadOnly || false
    initHttpInterceptor()
    initSystemConfig()
    initUserConfig()

    // 添加显示toast提示的监听器
    $rootScope.$on('showToast', function(event, data) {
      $utils.$notify.set({message: data.message})
    })

    // 全局服务器配置
    $rootScope.globalOptions = {}
    User.getGlobalOptions().then(res => {
      console.log('-- checkLicense --')
      $rootScope.globalOptions = res
      window.HX.options = angular.copy(res)

      if (!checkLicense()) {
        $state.go('forbid', {reason: 'license_expired'})
        $rootScope.$on('$stateChangeStart', event => event.preventDefault())
      }
    })

    /**
     * 检查license
     * 新License Key是 HXPHONE（永久授权）,只存在0,1,undefined三种情况
     * 旧License Key是 HXPED（有效期授权）。旧逻辑通过hxpInit.jsp检测，新逻辑详见CIM-27643
    * */
    function checkLicense () {
      if (process.env.NODE_ENV !== 'production') return true

      const licenseVersion = $rootScope.globalOptions.licenseVersion
      if (!licenseVersion) {
        console.warn('licenseVersion is null!')
        return false
      }

      const newExisted = !!get($rootScope.globalOptions, `license.PJ.${licenseVersion}.HXPHONE`)
      const oldExisted = !!get($rootScope.globalOptions, `license.PJ.${licenseVersion}.HXPED`)
      return newExisted || oldExisted
    }

    // 初始化JSBridge
    window.JSBridge = new JSBridge()

    function initWechatData() {
      if ($location.$$search.wechat) {
        $scope.wechatMiniNetFolder = false
        const wechatData = JSON.parse($location.$$search.wechat)
        console.log('wechat data: ', JSON.stringify(wechatData))
        // 监听URL变化，判断是否展示header
        window.addEventListener('hashchange', event => {
          const newUrl = event.newURL
          const oldUrl = event.oldURL
          if (newUrl.includes('/frame/read/')) {
            // 不展示header
            $rootScope.settings.wechatMiniShowHeader = false
            // 暂时采用操作Dom来隐藏ion-nav-bar 原因是在小程序web-view中，数据双向绑定隐藏ion-nav-bar没有同步变化
            setTimeout(() => {
              const globalIconNavBar = document.querySelector('#global-icon-nav-bar')
              globalIconNavBar.classList.add('wechat-no-header')
            })
            setTimeout(() => {
              document.querySelector('#wechat-read-header').classList.add('wechat-has-header')
            })
          }
          if (newUrl.includes('/frame/compose/')) {
            // 展示header
            $rootScope.settings.wechatMiniShowHeader = true
          }
          if (newUrl.includes('/frame/schedule')) {
            const scheduleHeader = document.querySelector('#wechat-schedule-content')
            scheduleHeader.classList.add('wechat-has-header')
          }
          // 写信返回往来附件
          if (newUrl.includes('/frame/nfList/rel/') && oldUrl.includes('/frame/compose/composeWithInternalAttachment/')) {
            // 不展示header
            $rootScope.settings.wechatMiniShowHeader = false
            setTimeout(() => {
              const globalIconNavBar = document.querySelector('#global-icon-nav-bar')
              const netFolderHeader = document.querySelector('#wechat-netFolder-header')
              globalIconNavBar.classList.add('wechat-no-header')
              netFolderHeader.classList.add('wechat-has-header')
            })
          }
        })
        if (wechatData.noShowHeader) {
          // 不展示header
          $rootScope.settings.wechatMiniShowHeader = false
          setTimeout(() => {
            const globalIconNavBar = document.querySelector('#global-icon-nav-bar')
            const netFolderHeader = document.querySelector('#wechat-netFolder-header')
            globalIconNavBar.classList.add('wechat-no-header')
            netFolderHeader.classList.add('wechat-has-header')
          })
        }
        if (wechatData.netFolder) {
          $scope.wechatMiniNetFolder = true
        }

        // $cookies.remove('Coremail.sid')
        $cookies.remove('Coremail')
        // // $cookies.put('Coremail.sid', wechatData.sid, {path: '/'})
        // // $cookies.put('Coremail', wechatData.Coremail, {path: '/'})
        // User.getCurrentUser().sid && User.updateSid(wechatData.sid)
      }
    }

    function initLASDK(email) {
      if ($rootScope.settings.enableAnalytics) {
        const prodHost = 'https://betaweb.lunkr.cn'
        const devHost = 'http://cim.rd.mt'
        const host = ~location.host.indexOf('rd.mt') ? devHost : prodHost
        window.LA = new LA({
          email: email || location.hostname,
          ordName: location.hostname,
          client: 'h',
          version: VERSION, //eslint-disable-line
          url: `${host}/log/collect`
        })
      } else {
        window.LA = {
          track() {}
        }
      }
    }

    // 初始化请求拦截器
    function initHttpInterceptor() {
      let tipView = null

      // session 过期的处理(FA_INVALID_SESSION) 或cookie 不匹配(FA_SECURITY)
      const handlerInvalidSession = function(options, reason) {
        if ($utils.$misc.MD.isAppEmbed) { //  单点登录session过期处理
          globalHook.exec('handleInvalidSession').catch(_ => {
            $translate('CODE.GLOBAL.SSO_FA_INVALID_SESSION').then(res => {
              $utils.$notify.set({ message: res })
            })
          })
        } else if (!tipView) {
          $q.all([
            $translate('TIPS.SYSTEM_MESSAGE'), $translate('CODE.GLOBAL.FA_INVALID_SESSION')
          ]).then(res => {
            tipView = $ionicPopup.alert({
              title: res[0], template: res[1]
            }).then(_ => {
              tipView = ''
              $state.go('login')
            })
          })
        }
        return $q.reject(reason.data)
      }

      // 强制二次验证开启时，未绑定二次验证用户不能访问邮箱核心业务接口
      const handlerEnForceSettings = function (options, reason) {
        if (!tipView) {
          $q.all([
            $translate('VERIFICATION.ACCOUNT_VERIFY'), $translate('VERIFICATION.NEED_BIND_ACCOUNT_VERIFY')
          ]).then(res => {
            tipView = $ionicPopup.alert({
              title: res[0], template: res[1]
            }).then(_ => {
              tipView = ''
            })
          })
        }

        return $q.reject(reason.data)
      }

      forEach(['FA_INVALID_SESSION', 'FA_SECURITY'], item => {
        HttpInterceptor.responseHandler[item] = handlerInvalidSession
      })

      HttpInterceptor.responseHandler['FA_ENFORCE_SETTINGS_INCOMPLETE'] = handlerEnForceSettings
    }

    /**
     * 检查是否是微信小程序环境
     */
    function checkEnv() {
      // document.addEventListener('UniAppJSBridgeReady', function() {
      uni.getEnv(function(res) {
        console.log('当前环境：' + JSON.stringify(res))
        if (res.miniprogram) {
          $rootScope.settings.wechatMiniProgram = true
          console.log('wechatMiniProgram: ', $rootScope.settings.wechatMiniProgram)
        }
      })
      // })
    }

    $scope.handleTouchStart = function (evt) {
      // 这里会导致部分浏览器滑动无法返回，但是这部分影响也比较大，通过配置方便随时开启
      $rootScope.settings.enableIosSlide && $utils.$detector.os.name == 'ios' && evt.preventDefault()
    }

    /*
     * 用于检测全局的网络变化
     * 值得注意的是，还存在网络timeout的情况的失败，如此需要在httpInterceptor处理，
     * 但是细度太小（页面渲染数据获取失败才需要清理缓存）可能导致部分异常请求影响缓存，故放弃
     */
    window.addEventListener('online', function () {
      $ionicConfig.views.forwardCache(true)
      $scope.offline = false
    })
    window.addEventListener('offline', function () {
      $ionicConfig.views.forwardCache(false)
      $scope.offline = true
      // $utils.$notify.set({message: $translate.instant("TIPS.NO_NETWORK")});
    })

    // do something when login success
    $rootScope.$on('LOGIN.SUCCESS', function (e, config) {
      console.log('receive login success')
      initUserConfig()
    })

    /** 读取用户配置 */
    /** load user configuration */
    function initUserConfig() {
      const userConfig = User.getConfig()
      const $ajc = userConfig['$ajc']

      $scope.userConfig = userConfig
      $rootScope.hasPerNetfolder = userConfig.perm_func_netfolder || get(userConfig, '$ajc.nf.enabled')
      $rootScope.hasEntNetfolder = get(userConfig, '$ajc.nf.enfEnabled')

      /** 加载当前用户的组织配置(TODO: 使用 globalConfig.getUserClientConf 可能会更新不及时) */
      if (serverConfig.getItem('useCustomSettings')) {
        const orgId = get($ajc, 'user.orgId')
        $rootScope.settings = globalConfig.settings = merge(
          $rootScope.settings,
          orgId ? $utils.$loadSync.loadJSON('json/custom/custom_settings.' + orgId + '.json') : {}
        )
      }
      const debug = $rootScope.settings.debug
      const allowDebug = angular.isString(debug)
        ? !!~debug.split(/\s*,\s*/).indexOf(userConfig.email) // 配置允许开启的用户
        : debug
      allowDebug ? globalVconsole.showSwitch() : globalVconsole.hideSwitch()

      /* 服务等级关闭共享邮箱功能 */
      $rootScope.settings.settingMenu.sharedMailbox = get($ajc, 'mboxShare.enabled', $rootScope.settings.settingMenu.sharedMailbox)

      /** 初始化统计 SDK */
      initLASDK(userConfig.email)

      /** 初始化IndexedDB缓存系统  **/
      IndexedDB.config(userConfig.email)

      flushSkin()

      window.HX.$ = {
        localStorage: LocalStorage,
        jSBridge: JSBridge,
        indexedDB: IndexedDB,
        wmCall: Promise.wmCall,
        cookie: $cookies,
        utils: $utils,
        i18n: $translate
      }
    }

    function flushSkin() {
      /** update skin */
      /** 更新皮肤 */
      Skin.reload($rootScope.settings.skins)
    }

    /** 读取系统配置 */
    /** load system configuration */
    function initSystemConfig() {
      // 设置wmsvr接口路径
      const coremailUrl = $location.$$search.coremailurl || window.coremailurl
      if (coremailUrl) {
        LocalStorage[coremailUrl === 'null' ? 'removeItem' : 'setItem']('coremailurl', convertToAbsURL(coremailUrl))
      }

      // 加载组织对应的favicon
      if ($rootScope.settings.favicon) {
        const link = document.createElement('link')
        link.type = 'image/x-icon'
        link.rel = 'shortcut icon'
        link.href = $rootScope.settings.favicon
        document.getElementsByTagName('head')[0].appendChild(link)
      }

      // 允许路由中的debug覆盖配置里面的debug
      const debug = $location.$$search.debug
      if (!angular.isUndefined(debug)) {
        $rootScope.settings.debug = ~['true', 'false'].indexOf(debug) ? debug !== 'false' : debug
      }

      flushSkin()
    }

    /** 监听系统配置，将系统配置写入到 localstorage */
    /** 共享给 hxphone-sub 项目使用 */
    $scope.$watch('settings', function(value) {
      localStorage.setItem('settings', JSON.stringify(value))
    })
  }]



// WEBPACK FOOTER //
// ./src/js/controllers/mainCtrl.js